import { api } from './axios';

export const cancelPayroll = (
  businessId: string,
  payrollUUID: string,
  reason: string,
): Promise<void> =>
  api.post('/tickets/cancel-payroll', {
    businessId,
    payrollUuid: payrollUUID,
    reason,
  });

export const requestChangePayroll = (
  businessId: string,
  reason: string,
  date?: string,
  payrollUUID?: string,
) =>
  api.post('tickets/request-payroll-change', {
    businessId,
    payrollUuid: payrollUUID,
    reason,
    date,
  });

export const submitRequestOffCyclePayroll = (
  amount: number,
  date: string,
  businessId: string,
  includeTaxes: boolean,
  reason?: string,
): Promise<void> =>
  api.post('/tickets/payroll-off-cycle', {
    businessId,
    amount,
    date,
    includeTax: includeTaxes,
    reason,
  });

export const createSupportTicket = (businessId: string, type: string) =>
  api.post(`/tickets/business/${businessId}/${type}`, type);
